<div class="trinka_cloud_wrap">
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text">
                        <h1>抄袭检查工具</h1>
                        <h2>避免抄袭和检测AI生成的内容</h2>
                        <ul class="highted-points">
                            <li>使用备受信赖的iThenticate报告检查付费出版论文的抄袭</li>
                            <li>检测任何文档中AI生成的内容</li>
                            <li>获得免费抄袭检查以及重复内容来源报告</li>
                        </ul>
                        <a href="https://cloud.trinka.ai/signup" id="autoEditGetStart" target="_blank">开始使用</a>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="mainSliderSection text-center">
                        <video class="vid-video" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" poster="../../../../../assets/images/plagiarism-check/plagiarism-check.jpg">
                            <source src="assets/images/plagiarism-check/plagiarism-check.mp4#t=0.1" type="video/mp4">
                            Your browser does not support the video element. Kindly update it to latest version.
                        </video>
                        <button class="icon-pause" (click)="playPause()" [ngClass]="video_pause ? 'icon-play' : 'icon-pause'"> </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="section-lg trustedby">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <h3>全球领导者信赖的选择</h3>
            </div>
            <div class="col-12">
                <div id="client-logos_white" class="owl-carousel">
                    <div class="item">
                        <div class="clientLogo">
                            <img src="assets/images/plagiarism-check/clients/mit.svg" class="filter" alt="mit">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="assets/images/plagiarism-check/clients/IEEE.svg" class="filter" alt="IEEE">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="assets/images/plagiarism-check/clients/stanford.svg"  class="filter" alt="standord">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="assets/images/plagiarism-check/clients/wiley.svg" class="filter" alt="wiley">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="assets/images/plagiarism-check/clients/harvard-white.svg" alt="harvard">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="assets/images/plagiarism-check/clients/caltech.svg" class="filter" alt="caltech">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="assets/images/plagiarism-check/clients/mu.svg" class="filter" alt="mu">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="assets/images/plagiarism-check/clients/polyglots.png" class="img-fluid" alt="polyglots">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="assets/images/plagiarism-check/clients/pfizer.svg" class="filter" alt="pfizer">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="assets/images/plagiarism-check/clients/abbott.svg" class="filter" alt="abbott">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="assets/images/plagiarism-check/clients/princeton-white.svg" alt="princeton">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<div class="writing_need_sections section-lg">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="section-tl">
                    <h2>找到最适合您的抄袭检查工具</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="standout-tbl">
                    <div class="table-responsive">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th>对比文本/特点</th>
                                    <th>
                                        免费点数<br/>
                                        <p class="powered-by"><span>技术提供</span> <img src="assets/images/plagiarism-check/iThenticate_logo.svg" class="iThenticate-logo" width="90" alt="iThenticate" /></p>
                                    </th>
                                    <th>标准抄袭检查
                                    </th>
                                    <th>高级抄袭检查<br/>
                                        <p class="powered-by"><span>技术提供</span> <img src="assets/images/plagiarism-check/iThenticate_logo.svg" class="iThenticate-logo" width="90" alt="iThenticate" /></p>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- <tr>
                                    <td>AI生成内容检测器 <span class="newbadge">全新</span></td>
                                    <td>-</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>-</td>
                                </tr> -->
                                <tr>
                                    <td>8900万付费学术文章</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>-</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                </tr>
                                <tr>
                                    <td>990亿个当前和已归档的网页</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                </tr>
                                <tr>
                                    <td>2亿个开放获取文章</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                </tr>
                                <tr>
                                    <td>每日搜索更新1.02亿个网页</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                </tr>
                                <tr>
                                    <td>交互式报告，可下载PDF</td>
                                    <td>-</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="single-wrapper section-md">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="wrap-content">
                    <h3>订阅<span>Trinka高级Plus</span>，获取无限访问标准抄袭检查</h3>
                    <a [routerLink]="['/pricing']" routerLinkActive="active" class="btn-outline-enago">
                        <span>了解更多</span> <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                            <path d="M12.5248 15.6833C12.3664 15.6833 12.2081 15.625 12.0831 15.5C11.8414 15.2583 11.8414 14.8583 12.0831 14.6166L16.6998 9.99998L12.0831 5.38331C11.8414 5.14164 11.8414 4.74164 12.0831 4.49998C12.3248 4.25831 12.7248 4.25831 12.9664 4.49998L18.0248 9.55831C18.2664 9.79998 18.2664 10.2 18.0248 10.4416L12.9664 15.5C12.8414 15.625 12.6831 15.6833 12.5248 15.6833Z" fill="black"/>
                            <path d="M17.4415 10.625H3.4165C3.07484 10.625 2.7915 10.3417 2.7915 10C2.7915 9.65833 3.07484 9.375 3.4165 9.375H17.4415C17.7832 9.375 18.0665 9.65833 18.0665 10C18.0665 10.3417 17.7832 10.625 17.4415 10.625Z" fill="black"/>
                          </svg>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="plagCheckKeyFeatures section-lg">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="section-tl">
                    <h2>主要特点</h2>
                    <div class="HeadingSubLine"></div>
                </div>
                <div class="tabs-wrap">
                    <ul class="nav nav-pills" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" data-toggle="pill" href="#freeScore">
                                <span>免费点数</span>
                                <div class="poweredBy">
                                    <img src="assets/images/plagiarism-check/iThenticate_logo.svg" width="115" class="iThenticate-logo" alt="iThenticate_logo" />
                                </div>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-toggle="pill" href="#standardPlagiarism">
                                <span>标准抄袭检查</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link " data-toggle="pill" href="#advancedPlagiarism">
                                <span>高级抄袭检查</span>
                                <div class="poweredBy">
                                    <img src="assets/images/plagiarism-check/iThenticate_logo.svg" width="115" class="iThenticate-logo" alt="iThenticate_logo" />
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="tab-content">
                    <div id="freeScore" class="tab-pane active">
                        <div class="pc-para">
                            <span>检查互联网来源并检测AI生成的内容</span>
                        </div>
                        <div class="row match-box">
                            <div class="col-lg-6">
                                <div class="c-card key-features-left">
                                    <div id="accordion_free" class="accordion">
                                        <div class="card" [ngClass]="freeshowTab == 1 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="card-link" (click)="freeScore(1)" data-toggle="collapse" href="#freecollapseOne">
                                                    <span><img src="assets/images/plagiarism-check/text-block.svg" alt="icon" /></span>
                                                    前3个匹配来源
                                                </a>
                                            </div>
                                            <div id="freecollapseOne" class="collapse show" data-parent="#accordion_free">
                                                <div class="card-body">
                                                    <p>列出前3个匹配的来源以及匹配百分比。</p>
                                                </div>
                                            </div>
                                        </div>
                                      
                                        <div class="card" [ngClass]="freeshowTab == 2 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="freeScore(2)" data-toggle="collapse" href="#freecollapseTwo">
                                                    <span><img src="assets/images/plagiarism-check/sources.svg" alt="icon" /></span>
                                                    显示总体相似度积分
                                                </a>
                                            </div>
                                            <div id="freecollapseTwo" class="collapse" data-parent="#accordion_free">
                                                <div class="card-body">
                                                    <p>根据检测到的抄袭问题，将获得文章内容相似度分数。</p>
                                                </div>
                                            </div>
                                        </div>
                                      
                                        <div class="card" [ngClass]="freeshowTab == 3 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="freeScore(3)" data-toggle="collapse" href="#freecollapseThree">
                                                    <span><img src="assets/images/plagiarism-check/text-block.svg" alt="icon" /></span>
                                                    互联网匹配和付费出版物分数
                                                </a>
                                            </div>
                                            <div id="freecollapseThree" class="collapse" data-parent="#accordion_free">
                                                <div class="card-body">
                                                    <p>文档显示互联网和付费来源的各别分数。</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="c-card key-features-right">
                                    <div class="image" [ngClass]="freeshowTab == 1 ? 'show' : ''">
                                        <img src="assets/images/plagiarism-check/matching-scroe.svg" alt="matching-score" class="matching sources" />
                                    </div>
                                    <div class="image" [ngClass]="freeshowTab == 2 ? 'show' : ''">
                                        <img src="assets/images/plagiarism-check/overall-score.svg" alt="overall-score" class="highlight" />
                                    </div>
                                    <div class="image" [ngClass]="freeshowTab == 3 ? 'show' : ''">
                                        <img src="assets/images/plagiarism-check/overall-paid.svg" alt="overall-paid" class="flags hidden" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="standardPlagiarism" class="tab-pane">
                        <div class="pc-para">
                            <span>检查互联网来源并检测AI生成的内容</span>
                        </div>
                        <div class="row match-box">
                            <div class="col-lg-6">
                                <div class="c-card key-features-left">
                                    <div id="accordion_standard" class="accordion">
                                        <!-- <div class="card" [ngClass]="standardshowTab == 1 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="card-link" (click)="standardPlagiarism(1)" data-toggle="collapse" href="#standardcollapseOne">
                                                    <span><img src="assets/images/plagiarism-check/cpu-charge.svg" alt="icon" /></span>
                                                    AI生成内容检测器
                                                </a>
                                            </div>
                                            <div id="standardcollapseOne" class="collapse show" data-parent="#accordion_standard">
                                                <div class="card-body">
                                                    <p>检测由大型语言模型（如ChatGPT）生成的内容。</p>
                                                </div>
                                            </div>
                                        </div> -->
                                      
                                        <div class="card" [ngClass]="standardshowTab == 2 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="card-link" (click)="standardPlagiarism(2)" data-toggle="collapse" href="#standardcollapseTwo">
                                                    <span><img src="assets/images/plagiarism-check/sources.svg" alt="icon" /></span>
                                                    识别前个匹配来源
                                                </a>
                                            </div>
                                            <div id="standardcollapseTwo" class="collapse show" data-parent="#accordion_standard">
                                                <div class="card-body">
                                                    <p>列出前个匹配的来源以及匹配百分比。</p>
                                                </div>
                                            </div>
                                        </div>
                                      
                                        <div class="card" [ngClass]="standardshowTab == 3 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="standardPlagiarism(3)" data-toggle="collapse" href="#standardcollapseThree">
                                                    <span><img src="assets/images/plagiarism-check/text-block.svg" alt="icon" /></span>
                                                    突出显示匹配的文本
                                                </a>
                                            </div>
                                            <div id="standardcollapseThree" class="collapse" data-parent="#accordion_standard">
                                                <div class="card-body">
                                                    <p>对于匹配的来源，报告会突出显示确切的匹配文本。</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="card" [ngClass]="standardshowTab == 4 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="standardPlagiarism(4)" data-toggle="collapse" href="#standardcollapseFour">
                                                    <span><img src="assets/images/plagiarism-check/flag-2.svg" alt="icon" /></span>
                                                    标记隐藏内容
                                                </a>
                                            </div>
                                            <div id="standardcollapseFour" class="collapse" data-parent="#accordion_standard">
                                                <div class="card-body">
                                                    <p>检测并标记文档中的隐藏文本和可疑字符。</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="card" [ngClass]="standardshowTab == 5 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="standardPlagiarism(5)" data-toggle="collapse" href="#standardcollapseFive">
                                                    <span><img src="assets/images/plagiarism-check/share_1.svg" alt="icon" /></span>
                                                    排除选择的部分
                                                </a>
                                            </div>
                                            <div id="standardcollapseFive" class="collapse" data-parent="#accordion_standard">
                                                <div class="card-body">
                                                    <p>提供排除文档中选择部分的灵活性。</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="c-card key-features-right">
                                    <div class="image video-feature" [ngClass]="standardshowTab == 1 ? 'show' : ''">
                                        <video class="vid-video" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" poster="assets/images/videos/posters/plagiarism-check.jpg">
                                            <source src="assets/images/plagiarism-check/AI-Content-Detector.mp4#t=0.1" type="video/mp4">
                                            Your browser does not support the video element. Kindly update it to latest version.
                                        </video>
                                    </div>
                                    <div class="image" [ngClass]="standardshowTab == 2 ? 'show' : ''">
                                        <img src="assets/images/plagiarism-check/sources.png" alt="paid publications" class="matching sources" />
                                    </div>
                                    <div class="image" [ngClass]="standardshowTab == 3 ? 'show' : ''">
                                        <img src="assets/images/plagiarism-check/highlight.png" alt="paid publications" class="highlight" />
                                    </div>
                                    <div class="image" [ngClass]="standardshowTab == 4 ? 'show' : ''">
                                        <img src="assets/images/plagiarism-check/flags-hidden.png" alt="paid publications" class="flags hidden" />
                                    </div>
                                    <div class="image" [ngClass]="standardshowTab == 5 ? 'show' : ''">
                                        <img src="assets/images/plagiarism-check/eclude-choosen.png" alt="paid publications" class="exclude choosen" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="advancedPlagiarism" class="tab-pane">
                        <div class="pc-para">
                            <span>对比付费文章和互联网资源检查 <br/>
                                学术论文抄袭检查工具推荐</span>
                        </div>
                        <div class="row match-box">
                            <div class="col-lg-6">
                                <div class="c-card key-features-left">
                                    <div id="accordion" class="accordion">
                                        <div class="card" [ngClass]="showTab == 1 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="card-link" (click)="advancePlagiarism(1)" data-toggle="collapse" href="#collapseOne">
                                                    <span><img src="assets/images/plagiarism-check/sources.svg" alt="icon" /></span>
                                                    识别前个匹配来源
                                                </a>
                                            </div>
                                            <div id="collapseOne" class="collapse show" data-parent="#accordion">
                                                <div class="card-body">
                                                    <p>列出前个匹配的来源以及匹配百分比。</p>
                                                </div>
                                            </div>
                                        </div>
                                      
                                        <div class="card" [ngClass]="showTab == 2 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="advancePlagiarism(2)" data-toggle="collapse" href="#collapseTwo">
                                                    <span><img src="assets/images/plagiarism-check/text-block.svg" alt="icon" /></span>
                                                    突出显示匹配的文本
                                                </a>
                                            </div>
                                            <div id="collapseTwo" class="collapse" data-parent="#accordion">
                                                <div class="card-body">
                                                    <p>对于匹配的来源，报告会突出显示确切的匹配文本。</p>
                                                </div>
                                            </div>
                                        </div>
                                      
                                        <div class="card" [ngClass]="showTab == 3 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="advancePlagiarism(3)" data-toggle="collapse" href="#collapseThree">
                                                    <span><img src="assets/images/plagiarism-check/flag-2.svg" alt="icon" /></span>
                                                    标记隐藏内容
                                                </a>
                                            </div>
                                            <div id="collapseThree" class="collapse" data-parent="#accordion">
                                                <div class="card-body">
                                                    <p>检测并标记文档中的隐藏文本和可疑字符。</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="card" [ngClass]="showTab == 4 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="advancePlagiarism(4)" data-toggle="collapse" href="#collapseFour">
                                                    <span><img src="assets/images/plagiarism-check/export.svg" alt="icon" /></span>
                                                    排除选择的部分
                                                </a>
                                            </div>
                                            <div id="collapseFour" class="collapse" data-parent="#accordion">
                                                <div class="card-body">
                                                    <p>提供排除文档中选择部分的灵活性。</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="card" [ngClass]="showTab == 5 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="advancePlagiarism(5)" data-toggle="collapse" href="#collapseFive">
                                                    <span><img src="assets/images/plagiarism-check/share_1.svg" alt="icon" /></span>
                                                    提供分享选项
                                                </a>
                                            </div>
                                            <div id="collapseFive" class="collapse" data-parent="#accordion">
                                                <div class="card-body">
                                                    <p>提供多种选项，可无缝分享您的报告。</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 dflex">
                                <div class="c-card key-features-right">
                                    <div class="image" [ngClass]="showTab == 1 ? 'show' : ''">
                                        <img src="assets/images/plagiarism-check/sources.png" alt="paid publications" class="matching sources" />
                                    </div>
                                    <div class="image" [ngClass]="showTab == 2 ? 'show' : ''">
                                        <img src="assets/images/plagiarism-check/highlight.png" alt="paid publications" class="highlight" />
                                    </div>
                                    <div class="image" [ngClass]="showTab == 3 ? 'show' : ''">
                                        <img src="assets/images/plagiarism-check/flags-hidden.png" alt="paid publications" class="flags hidden" />
                                    </div>
                                    <div class="image" [ngClass]="showTab == 4 ? 'show' : ''">
                                        <img src="assets/images/plagiarism-check/eclude-choosen.png" alt="paid publications" class="exclude choosen" />
                                    </div>
                                    <div class="image" [ngClass]="showTab == 5 ? 'show' : ''">
                                        <img src="assets/images/plagiarism-check/share.png" alt="paid publications" class="share" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-lg standOut">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="section-tl">
                    <h2>Trinka抄袭检测器的独特之处是什么？ </h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="standout-tbl">
                    <div class="table-responsive">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Trinka & <br/> Enago Reports</th>
                                    <th class="grammarly">Grammarly</th>
                                    <th class="quillbot">Quillbot</th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- <tr>
                                    <td>AI生成内容检测器</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>-</td>
                                    <td>-</td>
                                </tr> -->
                                <tr>
                                    <td>
                                        <p>
                                            iThenticate报告
                                            <span class="custom-tooltip">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                    <path d="M10 1.04164C14.9417 1.04165 18.9584 5.05831 18.9584 9.99998C18.9584 14.9416 14.9417 18.9583 10 18.9583C5.05837 18.9583 1.04171 14.9416 1.04171 9.99998C1.04171 5.05831 5.05838 1.04164 10 1.04164ZM10 17.7083C14.25 17.7083 17.7084 14.25 17.7084 9.99998C17.7084 5.74998 14.25 2.29165 10 2.29164C5.75004 2.29164 2.29171 5.74998 2.29171 9.99998C2.29171 14.25 5.75004 17.7083 10 17.7083Z" fill="#414E62"/>
                                                    <path d="M10 8.54165C10.3417 8.54165 10.625 8.82498 10.625 9.16665L10.625 13.3333C10.625 13.675 10.3417 13.9583 10 13.9583C9.65833 13.9583 9.375 13.675 9.375 13.3333L9.375 9.16665C9.375 8.82498 9.65833 8.54165 10 8.54165Z" fill="#414E62"/>
                                                    <path d="M10 5.83335C10.1084 5.83335 10.2167 5.85835 10.3167 5.90002C10.4167 5.94168 10.5084 6.00002 10.5917 6.07502C10.6667 6.15835 10.725 6.24168 10.7667 6.35002C10.8084 6.45002 10.8334 6.55835 10.8334 6.66668C10.8334 6.77502 10.8084 6.88335 10.7667 6.98335C10.725 7.08335 10.6667 7.17502 10.5917 7.25835C10.5084 7.33335 10.4167 7.39168 10.3167 7.43335C10.1167 7.51668 9.88337 7.51668 9.68337 7.43335C9.58337 7.39168 9.49171 7.33335 9.40837 7.25835C9.33337 7.17502 9.27504 7.08335 9.23337 6.98335C9.19171 6.88335 9.16671 6.77502 9.16671 6.66668C9.16671 6.55835 9.19171 6.45002 9.23337 6.35002C9.27504 6.24168 9.33337 6.15835 9.40837 6.07502C9.49171 6.00002 9.58337 5.94168 9.68337 5.90002C9.78337 5.85835 9.89171 5.83335 10 5.83335Z" fill="#414E62"/>
                                                </svg>
                                                <div class="custom-tooltip-content custom-tooltip-transform">
                                                    高级抄袭检查提供
                                                </div>
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>-</td>
                                    <td>-</td>
                                </tr>
                                <tr>
                                    <td>
                                        <p>
                                            标准抄袭检查
                                            <span class="custom-tooltip">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                    <path d="M10 1.04164C14.9417 1.04165 18.9584 5.05831 18.9584 9.99998C18.9584 14.9416 14.9417 18.9583 10 18.9583C5.05837 18.9583 1.04171 14.9416 1.04171 9.99998C1.04171 5.05831 5.05838 1.04164 10 1.04164ZM10 17.7083C14.25 17.7083 17.7084 14.25 17.7084 9.99998C17.7084 5.74998 14.25 2.29165 10 2.29164C5.75004 2.29164 2.29171 5.74998 2.29171 9.99998C2.29171 14.25 5.75004 17.7083 10 17.7083Z" fill="#414E62"/>
                                                    <path d="M10 8.54165C10.3417 8.54165 10.625 8.82498 10.625 9.16665L10.625 13.3333C10.625 13.675 10.3417 13.9583 10 13.9583C9.65833 13.9583 9.375 13.675 9.375 13.3333L9.375 9.16665C9.375 8.82498 9.65833 8.54165 10 8.54165Z" fill="#414E62"/>
                                                    <path d="M10 5.83335C10.1084 5.83335 10.2167 5.85835 10.3167 5.90002C10.4167 5.94168 10.5084 6.00002 10.5917 6.07502C10.6667 6.15835 10.725 6.24168 10.7667 6.35002C10.8084 6.45002 10.8334 6.55835 10.8334 6.66668C10.8334 6.77502 10.8084 6.88335 10.7667 6.98335C10.725 7.08335 10.6667 7.17502 10.5917 7.25835C10.5084 7.33335 10.4167 7.39168 10.3167 7.43335C10.1167 7.51668 9.88337 7.51668 9.68337 7.43335C9.58337 7.39168 9.49171 7.33335 9.40837 7.25835C9.33337 7.17502 9.27504 7.08335 9.23337 6.98335C9.19171 6.88335 9.16671 6.77502 9.16671 6.66668C9.16671 6.55835 9.19171 6.45002 9.23337 6.35002C9.27504 6.24168 9.33337 6.15835 9.40837 6.07502C9.49171 6.00002 9.58337 5.94168 9.68337 5.90002C9.78337 5.85835 9.89171 5.83335 10 5.83335Z" fill="#414E62"/>
                                                </svg>
                                                <div class="custom-tooltip-content custom-tooltip-transform">
                                                    标准抄袭检查提供
                                                </div>
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>-</td>
                                    <td>-</td>
                                </tr>
                                <tr>
                                    <td>无限访问相似度报告</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>每月20页</td>
                                </tr>
                                <tr>
                                    <td>可下载的PDF报告</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>-</td>
                                    <td>-</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<section class="single-wrapper section-md">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="wrap-content">
                    <h3>使用<span>Trinka每月获得高达2</span>个免费的iThenticate积分</h3>
                    <a href="https://cloud.trinka.ai/signup" class="btn-outline-enago" target="_blank">
                        <span>开始使用</span> <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                            <path d="M12.5248 15.6833C12.3664 15.6833 12.2081 15.625 12.0831 15.5C11.8414 15.2583 11.8414 14.8583 12.0831 14.6166L16.6998 9.99998L12.0831 5.38331C11.8414 5.14164 11.8414 4.74164 12.0831 4.49998C12.3248 4.25831 12.7248 4.25831 12.9664 4.49998L18.0248 9.55831C18.2664 9.79998 18.2664 10.2 18.0248 10.4416L12.9664 15.5C12.8414 15.625 12.6831 15.6833 12.5248 15.6833Z" fill="black"/>
                            <path d="M17.4415 10.625H3.4165C3.07484 10.625 2.7915 10.3417 2.7915 10C2.7915 9.65833 3.07484 9.375 3.4165 9.375H17.4415C17.7832 9.375 18.0665 9.65833 18.0665 10C18.0665 10.3417 17.7832 10.625 17.4415 10.625Z" fill="black"/>
                          </svg>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-lg">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-xl-5 col-md-12">
                <div class="section-tl">
                    <h2>涵盖1700多个付费科学期刊</h2>
                    <div class="HeadingSubLine"></div>
                    <p>利用最准确的文本相似性检测算法来验证内容的抄袭情况，以保持其完整性和可信度。将您的文稿与Wiley、Springer Nature、Taylor & Francis、Sage等众多知名出版社发表的文章进行比较。</p>
                </div>
            </div>
            <div class="col-lg-6 col-xl-6 offset-xl-1  col-md-12">
                <div class="no-image">
                    <img src="assets/images/plagiarism-check/plagiarism-check-map.png" alt="plag check map" class="img-fluid" />
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-lg pt-0">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="section-tl">
                    <h2>使用Trinka的抄袭检查获得高质量的评估</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6 col-xl-6 col-md-12">
                <div class="section-tl">
                    <p>由于存在多种抄袭检测工具可供选择，选择合适的工具可能会具有挑战性。为了让您更轻松地完成此过程，我们比较了多种广泛使用的抄袭检测工具，结果显示Trinka提供了最可靠和准确的结果。</p>
                    <p>在对高度抄袭的样本论文进行测试时，Trinka抄袭检测器的性能超过了大多数其他工具。</p>
                    <p>基于6个参数，我们比较了3个领先的工具的准确性、数据库大小、可访问性、易用性、成本和安全性。Trinka提供了一流的评估和专业知识，同时保护您的数据的安全。</p>
                </div>
            </div>
            <div class="col-lg-6 col-xl-5 offset-xl-1  col-md-12">
                <div class="no-image">
                    <img src="assets/images/plagiarism-check/plagiarism-check-graph.jpg" alt="plag check graph" class="img-fluid" />
                </div>
            </div>
        </div>
    </div>
</section>

<section class="suitableForSection section-lg" style="background-color: #F5F7F8;">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="section-tl">
                    <h2>为什么选择Trinka抄袭检测器？</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
        </div>
        <div class="row match-box">
            <div class="col-lg-6 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">
                        <img src="assets/images/languageScore_icon.svg" width="40" height="40" alt="ppc"/>
                    </div>
                    <div class="media-body">
                        <h4>每月免费提供抄袭检查积分</h4>
                        <p>在生成报告之前，免费检查您的内容是否存在抄袭。您的文档将与互联网、开放获取和付费出版物比对，进行抄袭检查。</p>
                    </div>
                </div>
            </div>
            <!-- <div class="col-lg-6 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">
                        <img src="assets/images/plagiarism-check/ai-content-detector.svg" width="40" height="40" alt="ppc"/>
                    </div>
                    <div class="media-body">
                        <h4>AI生成内容检测</h4>
                        <p>在检查抄袭时，及时检测来自ChatGPT、GPT-4、Bard、Bing Chat等大型语言模型（LLM）的AI生成文本，以维护内容的完整性。</p>
                    </div>
                </div>
            </div> -->
            <div class="col-lg-6 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">
                        <img src="assets/images/plagiarism-check/standard-check.svg" width="40" height="40" alt="ppc"/>

                    </div>
                    <div class="media-body">
                        <h4>无限制标准抄袭检查</h4>
                        <p>获取无限制的标准抄袭检查可将您的内容与互联网来源和开放获取出版物进行比较。</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">
                        <img src="assets/images/plagiarism-check/detection-technology.svg" width="40" height="40" alt="ppc"/>

                    </div>
                    <div class="media-body">
                        <h4>卓越的检测技术</h4>
                        <p>我们的抄袭检查器检测技术得到了最大的学术出版商的应用，智能排除已引用的内容，为您提供可靠的结果。</p>
                    </div>
                </div>
            </div>
            <!-- <div class="col-lg-6 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                            <path d="M35 36.6665H5C4.31667 36.6665 3.75 36.0998 3.75 35.4165C3.75 34.7332 4.31667 34.1665 5 34.1665H35C35.6833 34.1665 36.25 34.7332 36.25 35.4165C36.25 36.0998 35.6833 36.6665 35 36.6665Z" fill="#6F2496"/>
                            <path d="M31.7 5.8001C28.4666 2.56677 25.3 2.48343 21.9833 5.8001L19.9666 7.81677C19.8 7.98343 19.7333 8.2501 19.8 8.48343C21.0666 12.9001 24.6 16.4334 29.0166 17.7001C29.0833 17.7168 29.15 17.7334 29.2166 17.7334C29.4 17.7334 29.5666 17.6668 29.7 17.5334L31.7 15.5168C33.35 13.8834 34.15 12.3001 34.15 10.7001C34.1666 9.0501 33.3666 7.4501 31.7 5.8001Z" fill="#6F2496"/>
                            <path d="M26.0169 19.2168C25.5335 18.9835 25.0669 18.7502 24.6169 18.4835C24.2502 18.2668 23.9002 18.0335 23.5502 17.7835C23.2669 17.6002 22.9335 17.3335 22.6169 17.0668C22.5835 17.0502 22.4669 16.9502 22.3335 16.8168C21.7835 16.3502 21.1669 15.7502 20.6169 15.0835C20.5669 15.0502 20.4835 14.9335 20.3669 14.7835C20.2002 14.5835 19.9169 14.2502 19.6669 13.8668C19.4669 13.6168 19.2335 13.2502 19.0169 12.8835C18.7502 12.4335 18.5169 11.9835 18.2835 11.5168C18.1718 11.2774 18.0715 11.0418 17.9791 10.8119C17.8431 10.4737 17.4064 10.3773 17.1487 10.635L7.23354 20.5502C7.01687 20.7668 6.81687 21.1835 6.76687 21.4668L5.86687 27.8502C5.70021 28.9835 6.01687 30.0502 6.71687 30.7668C7.31687 31.3502 8.15021 31.6668 9.05021 31.6668C9.25021 31.6668 9.45021 31.6502 9.65021 31.6168L16.0502 30.7168C16.3502 30.6668 16.7669 30.4668 16.9669 30.2502L26.8749 20.3422C27.1344 20.0826 27.0357 19.6394 26.6954 19.5019C26.4756 19.4131 26.2518 19.3186 26.0169 19.2168Z" fill="#6F2496"/>
                          </svg>
                    </div>
                    <div class="media-body">
                        <h4>Business Professionals</h4>
                        <p>Use the report to refine reports, proposals, or marketing collateral, for more effective communication.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                            <path d="M36.6668 31.6667V36.6667H3.3335V31.6667C3.3335 30.75 4.0835 30 5.00016 30H35.0002C35.9168 30 36.6668 30.75 36.6668 31.6667Z" fill="#6F2496" stroke="#6F2496" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M11.6668 18.3335H8.3335V30.0002H11.6668V18.3335Z" fill="#6F2496"/>
                            <path d="M18.3333 18.3335H15V30.0002H18.3333V18.3335Z" fill="#6F2496"/>
                            <path d="M24.9998 18.3335H21.6665V30.0002H24.9998V18.3335Z" fill="#6F2496"/>
                            <path d="M31.6668 18.3335H28.3335V30.0002H31.6668V18.3335Z" fill="#6F2496"/>
                            <path d="M38.3332 37.9165H1.6665C0.983171 37.9165 0.416504 37.3498 0.416504 36.6665C0.416504 35.9832 0.983171 35.4165 1.6665 35.4165H38.3332C39.0165 35.4165 39.5832 35.9832 39.5832 36.6665C39.5832 37.3498 39.0165 37.9165 38.3332 37.9165Z" fill="#6F2496"/>
                            <path d="M35.6168 9.5834L20.6168 3.5834C20.2835 3.45007 19.7168 3.45007 19.3835 3.5834L4.3835 9.5834C3.80016 9.81673 3.3335 10.5001 3.3335 11.1334V16.6667C3.3335 17.5834 4.0835 18.3334 5.00016 18.3334H35.0002C35.9168 18.3334 36.6668 17.5834 36.6668 16.6667V11.1334C36.6668 10.5001 36.2002 9.81673 35.6168 9.5834ZM20.0002 14.1667C18.6168 14.1667 17.5002 13.0501 17.5002 11.6667C17.5002 10.2834 18.6168 9.16673 20.0002 9.16673C21.3835 9.16673 22.5002 10.2834 22.5002 11.6667C22.5002 13.0501 21.3835 14.1667 20.0002 14.1667Z" fill="#6F2496"/>
                          </svg>
                    </div>
                    <div class="media-body">
                        <h4>Research Institutes</h4>
                        <p>Ensure the originality of the research work submitted for review with the help of our plagiarism check report with AI content detector.</p>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</section>

<div class="allAboutTrinkaCredit">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="aboutTrinkaCreditHeading">
                    <h2>抄袭检查使用积分</h2>
                    <div class="HeadingSubLine"></div>
                </div>
                <div class="creditSectionFeature">
                    <div class="othersPointsForCredits">
                        <p style="margin-bottom: 0px;">积分类似于代币，可根据需要使用多种Trinka功能。</p>
                        <p>高级用户每月获得10个积分，基本用户每月获得4个免费积分。了解更多信息，请<a [routerLink]="['/features/credits']">点击此处</a>。</p>
                    </div>
                    <div class="featurePointsCredits">
                        <span>
                            <img src="assets/images/credits_icon.png" alt="credits">
                        </span>
                        <p>标准抄袭检查需要使用12积分，而高级抄袭检查需要使用18积分。<br />充分利用您每月的免费积分，仅在需要时购买更多。</p>
                    </div>
                    <div class="othersPointsForCredits">
                        <p style="margin-bottom: 0px;">Trinka高级用户每月获得2次免费的抄袭检查。</p>
                        <p>此外，您还可享受高达6折的积分包购买折扣。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="section-lg bg-grey">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="section-tl">
                    <h2>如何使用</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="allPlans-wrapper">
                    <div class="plan-content plan-simple">
                        <div class="plan-header"></div>
                        <ul>
                            <li>免费点数</li>
                            <li>标准报告</li>
                            <li>进阶报告</li>
                            <li>每月获取新的积分</li>
                            <!-- <li>Additional Credit Discounting / Purchase</li> -->
                            <li>批量购买积分的价格</li>
                        </ul>
                    </div>
                    <div class="plan-content plan-basic">
                        <div class="plan-header">
                            基本
                        </div>
                        <ul>
                            <li><span>每月<b>1个免费积分</b></span></li>
                            <li><span>使用<b>12积分 </b></span></li>
                            <li><span>使用<b>18积分 </b></span></li>
                            <li><span>每月<b>4个积分</b></span></li>
                            <!-- <li><span><b>6 USD </b> per Extra Credit Purchase</span></li> -->
                            <li><span>每积分仅需<b class="d-inline">3美元</b><br/> （40个积分包）</span></li>
                        </ul>
                    </div>
                    <div class="plan-content plan-premium">
                        <div class="plan-header">
                            高级
                        </div>
                        <ul>
                            <li><span>每月<b>2个免费积分</b></span></li>
                            <li><span>使用<b>12积分 </b></span></li>
                            <li><span>使用<b>18积分 </b></span></li>
                            <li><span>每月<b>10个积分</b></span></li>
                            <!-- <li><span><b>3.6 USD</b> per Extra Credit Purchase</span></li> -->
                            <li><span>每积分仅需<b class="d-inline">1.8美元</b> <br/> （40个积分包）</span></li>
                        </ul>
                    </div>
                    <div class="plan-content plan-recommended">
                        <div class="plan-header">
                            高级 Plus
                            <span>推荐</span>
                        </div>
                        <ul>
                            <li><span>每月<b>2个免费积分</b></span></li>
                            <li><span><b>无限访问 </b></span></li>
                            <li><span>使用<b>18积分 </b></span></li>
                            <li><span>每月<b>10个积分</b></span></li>
                            <!-- <li><span><b>3.6 USD </b> per Extra Credit Purchase</span></li> -->
                            <li><span>每积分仅需<b class="d-inline">1.8美元</b><br/> （40个积分包）</span></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<section class="section-md gc-testimonials-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center testi">
                <div class="GCTestmonials">
                    <h2>使用感言</h2>
                    <div class="HeadingSubLine"></div>          
                </div>
            </div>
        </div>
    </div>
    <div class="testimonial text-center">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="testimonial-wrap">
                        <!-- <div class="testimonal-icon">
                            <img src="assets/images/testimonial.png" alt="grammar-checker-testimonial">
                        </div> -->
                        <div class="testimonial-slider">
                            <div id="testi" class="carousel slide" data-ride="carousel">
                                <ol class="carousel-indicators">
                                    <li data-target="#testi" data-slide-to="0" class="active"></li>
                                    <li data-target="#testi" data-slide-to="1"></li>
                                    <li data-target="#testi" data-slide-to="2"></li>
                                    <li data-target="#testi" data-slide-to="3"></li>
                                    <li data-target="#testi" data-slide-to="4"></li>
                                    <li data-target="#testi" data-slide-to="5"></li>
                                    <li data-target="#testi" data-slide-to="6"></li>
                                    <li data-target="#testi" data-slide-to="7"></li>
                                    <li data-target="#testi" data-slide-to="8"></li>
                                    <li data-target="#testi" data-slide-to="9"></li>
                                    <li data-target="#testi" data-slide-to="10"></li>
                                    <li data-target="#testi" data-slide-to="11"></li>
                                    <li data-target="#testi" data-slide-to="12"></li>
                                </ol>
                                <div class="carousel-inner">
                                    <div class="carousel-item active">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/James-Smith.jfif" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">我一下就爱上Trinka了。祝贺你们开发出这个可以大幅协助编辑的程序，尤其是符合重要的语法惯例和具备精简字数功能的工具。
                                                    </p>
                                                    <p class="authorNameText">James Smith</p>
                                                    <span class="authorDesignationText">学术编辑, 美国</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/Rosa-Diaz-Sandoval.jfif" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">对于说其他语言的人来说，用正确的英语语法和风格编写文章不是一件容易的事。如果没有辅助功能，尤其是学术写作，很难在文件中发现小错误。我尝试将TrinkaAI作为自动更正工具，并对建议的更正和反馈感到非常满意。通过反馈，能了解为什么必须考虑建议的更改。</p>
                                                    <p class="authorNameText">Rosa Diaz Sandoval</p>
                                                    <span class="authorDesignationText">物理和数学博士, 墨西哥</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/Dr_Farooq_Rathore.jpg" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">我使用Trinka两个多月了。我主要用它来改进我为国内和国际生物医学期刊撰写的科学手稿的语言、语法和句法。界面很用户友好，并且软件高效且好用。根据需要编辑手稿的不同选项有助于决定我需要关注的地方。自动编辑的帮助很大，带有修订历史的补充页面很有用。Trinka一直在更新，我写这篇文章时就注意到添加了一个新功能“一致性”。最好的部分是所有这些都是完全免费的。我强烈鼓励作者和研究人员，特别是那些英语不好的人尝试一下，亲眼目睹惊人的结果。</p>
                                                    <p class="authorNameText">Farooq Rathore博士</p>
                                                    <span class="authorDesignationText">助理教授兼系主任, 巴基斯坦</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/Georgieva-Milena.jpg" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Trinka.ai是我最喜欢的语法和拼写编辑。该应用程序使用效果好，快速而明确！完全满意！</p>
                                                    <p class="authorNameText">Milena Georgieva</p>
                                                    <span class="authorDesignationText">研究员</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/Dinesh-Gupta.jfif" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">这是一个超越Grammarly的语法检查工具！我用Trinka重新检查了用Grammarly检查过一些文件。看到来自印度的如此优越产品，我感到非常惊喜！</p>
                                                    <p class="authorNameText">Dinesh Gupta</p>
                                                    <span class="authorDesignationText">放射科医师, 印度</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/Edith-Davies.jpg" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">我已经测试过Trinka，并对其出色的功能印象深刻。它比我使用的语法检查器做得更好。做得好！我已经告诉我研究实验室的同事使用Trinka。希望在学术界得到广泛应用。</p>
                                                    <p class="authorNameText">Edith Davies</p>
                                                    <span class="authorDesignationText">博士生, 英国</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/Noor-Al-rishi.png" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Trinka AI建议的更正和反馈令我惊喜。使用简单，非常有益。</p>
                                                    <p class="authorNameText">Noor Al-rishi</p>
                                                    <span class="authorDesignationText">化学学者, 沙特阿拉伯</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/Nwaji-Jude.jpg" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">使用Trinka是美妙的体验，如果不使用它评估稿件，我几乎无法提交任何手稿。总之，Trinka成了我的是救命稻草。</p>
                                                    <p class="authorNameText">Nwaji Jude</p>
                                                    <span class="authorDesignationText">研究员</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/Stumpf-Curtis.jfif" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">我喜欢使用Trinka作为我编辑文稿的最终检查。它确实有助于找到在编辑过程中漏掉的剩余错误。我真的很喜欢这个平台。大拇指向下这个按钮非常有用。
                                                    </p>
                                                    <p class="authorNameText">Stumpf Curtis</p>
                                                    <span class="authorDesignationText">研究员</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/Dyke-Gareth.jfif" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">我认为Trinka.ai是一个非常有趣且很有发展潜力的主意，尤其是对于编辑/出版社/期刊。我使用这个平台检查我的编辑工作，非常有用。</p>
                                                    <p class="authorNameText">Gareth Dyke</p>
                                                    <span class="authorDesignationText">研究员</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/Bhargava-Sharma.jfif" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">我对整体表现感到满意。我使用Grammarly已经有很长一段时间了，但是在学术或技术写作方面，Trinka绝对是更好的选择。学术文件设置和自动文件编辑是我最喜欢的功能。</p>
                                                    <p class="authorNameText">Bhargava Sharma</p>
                                                    <span class="authorDesignationText">流行病学家, 印度</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/Ralph-Bailey.jfif" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Trinka已成为我语法校正的首选工具。人工智能驱动的更正和语言增强使写作变得更加容易。现在，我可以更专注于研究，而不是纠正文稿中的错误。</p>
                                                    <p class="authorNameText">Ralph Bailey</p>
                                                    <span class="authorDesignationText">神经科医生, 美国</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/Thomas-Andres.jfif" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">基于AMA风格指南的语法纠正和建议真的令人印象深刻！Trinka确实是医学写作最好的语法校正工具。
                                                    </p>
                                                    <p class="authorNameText">Thomas Andres</p>
                                                    <span class="authorDesignationText">心脏学专家, 巴西</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <a class="carousel-control-prev" href="#testi" data-slide="prev">
                                <span class="carousel-control-prev-icon"></span>
                            </a>
                            <a class="carousel-control-next" href="#testi" data-slide="next">
                                <span class="carousel-control-next-icon"></span>
                            </a> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="use_trinka_other_app accomplishBrilliantWrap">
    <div class="container">
        <div class="accomplishBrilliantSection">
            <h2>扫除抄袭疑云，自信提交您的稿件 </h2>
            <a href="https://cloud.trinka.ai/signup" target="_blank">开始使用</a>
        </div>
    </div>
</div>


<div class="pricingQuestionAnwser" #target>
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="pricingHeadingQuestion">
                    <h2>常见问题</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
            <div class="col-lg-1"></div>
            <div class="col-lg-10">
                <div class="pricingQuestionsList">
                    <div class="accordion" id="faq">
                        <div class="card">
                            <div class="card-header" id="QuestionOne">
                                <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                    Trinka的抄袭检查是如何运作的？</a>
                            </div>

                            <div id="QuestionOneContent" class="collapse show" aria-labelledby="QuestionOne" data-parent="#faq">
                                <div class="card-body">
                                    <h4>非常简单！</h4>
                                    <ol>
                                        <li>进入您的Trinka云账户（还没有注册免费账户？ <a href="https://cloud.trinka.ai/signup" target="_blank">现在就注册</a>！)</li>
                                        <li>从右侧面板上<strong>点击导航到抄袭检查页面</strong>。</li>
                                        <li>上传文件并选择适合您的检查。您也可以选择一个您已经上传到Trinka drive中的档案。</li>
                                        <li>在几分钟内获得详细的报告!</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" id="QuestionTwo">
                                <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                    aria-controls="QuestionTwoContent">
                                    Trinka的抄袭检查与其他的有什么不同？</a>
                            </div>

                            <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                <div class="card-body">
                                    <p>与其他工具不同，Trinka让您选择符合您需求的抄袭检查--网络内容或网络+付费出版物。我们在技术上与iThenticate合作，提供卓越的检测能力，受到全球各大型学术出版商的信任。</p>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header" id="QuestionThree">
                                <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                    aria-controls="QuestionThreeContent">
                                    我可以免费使用Trinka的抄袭检查吗？
                                </a>
                            </div>

                            <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                <div class="card-body">
                                    <!-- <p>Yes. All Basic users get 1 free Plagiarism Score every month. All Premium users get 2 free Plagiarism Score checks every month. You can run as many checks as you like with <a [routerLink]="['/features/credits']">credits</a>.</p> -->
                                    <p>您可以在Trinka上免费获得查重分数!</p>
                                    <p>如果您有一个基本账户，您每个月可以得到1次免费的查重检查。如果您有一个Trinka高级账户，您将每月获得2次免费的查重检查</p>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header" id="QuestionFour">
                                <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                    aria-controls="QuestionFourContent">
                                    抄袭检查报告可以下载吗？
                                </a>
                            </div>

                            <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                <div class="card-body">
                                    <p>是的! 报告是PDF格式的，可以在您生成报告后的任何时候下载。</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-lg-1"></div>
        </div>
    </div>
</div>
<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="//player.bilibili.com/player.html?aid=216105189&bvid=BV1Ba411M7h5&cid=777872717&page=1"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>

<!-- The Modal -->
<div class="modal" id="freePlagiarismScore">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header bb-none">
          <h4 class="modal-title">样本分数</h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
  
        <!-- Modal body -->
        <div class="modal-body">
          <img src="assets/images/reports/report_list_item.png" class="img-fluid" />
        </div>
      </div>
    </div>
</div>